import { sanitizeHref } from '../../domain/sanitize';

type PointerEventLike = {
  preventDefault: () => void;
};

function preventLinkActivation(event: PointerEventLike) {
  event.preventDefault();
}

export const EDITOR_IMG_PROPS = {
  draggable: false,
  onDragStart: (event: { preventDefault: () => void }) =>
    event.preventDefault(),
} as const;

export const EDITOR_LINK_PROPS = {
  draggable: false,
  tabIndex: -1,
  onClick: preventLinkActivation,
  onAuxClick: preventLinkActivation,
  onDragStart: (event: { preventDefault: () => void }) =>
    event.preventDefault(),
} as const;

export type ExportLinkProps = {
  href: string;
  target: '_blank';
  rel: 'noopener noreferrer';
};

export function exportHref(href: string): string | null {
  const safe = sanitizeHref(href);
  if (!safe || safe === '#') {
    return null;
  }
  return safe;
}

export function linkPropsForMode(
  editorMode: boolean,
  href: string,
): typeof EDITOR_LINK_PROPS | ExportLinkProps | null {
  if (editorMode) {
    return EDITOR_LINK_PROPS;
  }
  const resolved = exportHref(href);
  if (!resolved) {
    return null;
  }
  return {
    href: resolved,
    target: '_blank',
    rel: 'noopener noreferrer',
  };
}
